import { Component, Input, OnInit, AfterContentChecked } from '@angular/core';
import { ActivatedRoute, Params, Router} from '@angular/router';
import { Location } from '@angular/common';
import { ContentService } from '../shared/content.service';
import { ConfigService } from '../shared/config.service';
import { UtilsService } from '../shared/utils.service';

const type: string = 'record';

@Component({
    template: require('./partials/content-records.component.html'),
})
export class ContentRecordsComponent implements OnInit, AfterContentChecked {
    
    public pageSize = 12;
    public currentLanguage: string;
    public contents: any;

    constructor(private config: ConfigService, public utils: UtilsService, private contentService: ContentService, private route: ActivatedRoute, private location: Location, private router: Router) {
    }

    ngOnInit(){
        this.route.parent.params.subscribe(
            (params: Params) => {
                this.currentLanguage = params['lg'];
            }
        );

    }
    ngAfterContentChecked(){
        if(!this.currentLanguage){
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
        }     
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-records.component.ts